module.exports = "/assets/9f08ae4623ad8fb0e981f3cd0481b397.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JM.png
// module id = 2639
// module chunks = 0